import * as Crypto from "./Crypto";
import * as lodash from "./Lodash";
import { format, isToday, addHours } from "date-fns";
import { channelEnum } from "config/constants";
import moment from "moment";
import { IWarehousePayload } from "interfaces/Index";
import { defaultWarehouse } from "components/pages/riderManagement/RiderManagementConstants";
import { getFromLocal } from "../Cache";

export const CryptoJS = Crypto;
export const _ = lodash;

export const removeArrayOfObjectDuplicates = (
  newListToMerge: Array<any>,
  existingList: Array<any>,
  compareKey: string
) => {
  return newListToMerge.filter((item: any, index: number) => {
    var ItemIndex = existingList.findIndex(
      (ele: any) => ele[compareKey] === item[compareKey]
    );
    if (ItemIndex >= 0) return false;
    return true;
  });
};

export const formatToCurrency = (value: number, decimalPoint: number = 1) => {
  return Math.round(value) !== value
    ? value.toFixed(decimalPoint).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    : value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const convertDateFormat = (data: string) => {
  let today = new Date(data);
  if (isToday(today)) {
    return "Today, " + format(addHours(new Date(data), 5), "p");
  } else {
    return `${format(addHours(new Date(data), 5), "LLL d")} at ${format(
      addHours(new Date(data), 5),
      "p"
    )}`;
  }
};

export const convertDateFormatForUTC = (data: string) => {
  return `${format(addHours(new Date(data), 5), "yyyy-MM-dd HH:mm:ss")}`;
};

export const convertDateFormatForUTCTimeZone = (data: string) => {
  let formatData = data.split(" ");
  return formatData.join("T");
};

export const formatDate = (date: string, formatString: string) => {
  return format(new Date(date), formatString);
};

export const generateRefCode = () => {
  return Date.now().toString(36).toUpperCase().slice(0, 6);
};

export const autoGeneratePassword = () => {
  let randomFiveDigits = Math.floor(Math.random() * 90000) + 100000;
  return randomFiveDigits.toString();
};

export const orderListChannel = (e: any) => {
  if (e === "CUSTOMER_APP") {
    return channelEnum.CUSTOMER_APP;
  } else if (e === "AGENT_APP") {
    return channelEnum.AGENT_APP;
  } else if (e === "TELESALES_COMMANDO") {
    return channelEnum.TELESALES_COMMANDO;
  } else if (e === "CORPORATE_COMMANDO") {
    return channelEnum.CORPORATE_COMMANDO;
  } else if (e === "ADMIN_COMMANDO") {
    return channelEnum.ADMIN_COMMANDO;
  } else if (e === "KHATA_APP") {
    return channelEnum.KHAATA_APP;
  }
};

export const clickToFocus = (e: any) => {
  let value = e.target;
  value.select();
};

export const convertCurrenyToString = (currency: string) => {
  return currency.replace(/,/g, "");
};

export const isNumeric = (n: string) => {
  return !isNaN(parseFloat(n));
};

export const getTomorrowDate = () => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return tomorrow;
};

export const calculateDateDifference = (date: Date) => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const currentDate = new Date();
  const utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  const utc2 = Date.UTC(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );
  return Math.floor((utc1 - utc2) / _MS_PER_DAY);
};

export const convertCampaignDate = (data: string) => {
  return `${format(addHours(new Date(data), 5), "LLL d")} at ${format(
    addHours(new Date(data), 5),
    "p"
  )}`;
};

export const toTitleCase = (str: string) => {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const convertStringToMultiSelectDropdown = (value: string) => {
  return {
    id: value,
    label: value,
    value,
  };
};

export const convertStringArrayToMultiSelectDropdown = (arr: string[]) => {
  return arr.map((value) => convertStringToMultiSelectDropdown(value));
};

export const getWarehousePayloadById = (
  id: string,
  warehousesList: IWarehousePayload[]
) => {
  const foundWarehouse = warehousesList.find(
    (warehouse) => warehouse.id === id
  );
  return foundWarehouse === undefined ? defaultWarehouse : foundWarehouse;
};

export const isValidDate = (current: {
  isAfter: (arg0: moment.Moment) => any;
}) => {
  const yesterday = moment().subtract(1, "day");
  return current.isAfter(yesterday);
};

export const removeCharacterFromStringAndCapitalize = (
  str: string,
  charToRemove: string
) => {
  const strArr = str.toLowerCase().split(charToRemove); // "GENERAL_TRADE"
  return strArr.map((strWord) => capitalizeFirstLetter(strWord)).join(" ");
};

export const allowedRole = (role: string) => {
  const auth = getFromLocal("auth");
  return auth.roles.includes(role);
};
